import React from 'react';
interface ButtonGroupProps {
  text: string;
}
const ButtonGroup = ({text}: ButtonGroupProps) => {
  return (
    <>
      {text.length !== 0 ? (
        <button
          type="submit"
          className="text-primary icon-send-button text-[30px]"
        />
      ) : (
        <button type="button" className="text-primary icon-link text-[40px]" />
      )}
    </>
  );
};

export default ButtonGroup;
